var render = function render(){var _vm=this,_c=_vm._self._c;return (
    !_vm.getConfigJs.isClosed &&
    !_vm.getConfigJs.isContinueChatEnabled &&
    _vm.getConfigJs.isVerified
  )?_c('div',{staticClass:"flex text-xs items-center text-success font-italic gap-1"},[_c('span',{staticClass:"material-symbols-outlined text-xs text-success"},[_vm._v("verified")]),_c('span',[_vm._v("Verified")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }